import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "../../actions";
import Image from '../../components/Image/Image.jsx';

class ConformationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: ""
        }
    }
    componentWillMount() {

    }
    componentDidMount() {

    }
    render() {
        // if (this.props.open && this.props.autoClose & this.state.timeout != "") {
        //     this.setState({
        //         timeOut: setTimeout(
        //             () => {
        //                 this.props.modalClose();
        //                 this.setState({timeout: ""});
        //             }, 2000)
        //     });
        // }
        if (!this.props.open && this.state.timeout != "") {
            this.setState({ timeout: "" });
        }
        return (
            <div id="notifyModal" className="modal" tabIndex="-1" role="dialog" aria-labelledby="costumModalLabel" aria-hidden="true" style={this.props.open ? { display: 'block' } : {}} onClick={this.props.modalClose}>
                <div className="modal-dialog modal-sm modal-dialog-centered">
                    <div className={this.props.notifyType == 2 ? "modal-content text-center animated bounceIn" : "modal-content text-center animated shake"}> {/* shake class when alert */}
                        <div className="modal-body">
                            {/* {this.props.notifyType == 1
                                ? ( */}


                            <div className="f-modal-alert">
                                {
                                    this.props.notifyType == 1 ?
                                        <div className="f-modal-icon f-modal-error animate">
                                            <span className="f-modal-x-mark">
                                                <span className="f-modal-line f-modal-left animateXLeft"></span>
                                                <span className="f-modal-line f-modal-right animateXRight"></span>
                                            </span>
                                            <div className="f-modal-placeholder"></div>
                                            <div className="f-modal-fix"></div>
                                        </div>
                                        : this.props.notifyType == 2 ?
                                            <div className="f-modal-icon f-modal-success animate">
                                                <span className="f-modal-line f-modal-tip animateSuccessTip"></span>
                                                <span className="f-modal-line f-modal-long animateSuccessLong"></span>
                                                <div className="f-modal-placeholder"></div>
                                                <div className="f-modal-fix"></div>
                                            </div>
                                            : <div className="f-modal-icon f-modal-warning animate">
                                                <span className="f-modal-body pulseWarningIns"></span>
                                                <span className="f-modal-dot pulseWarningIns"></span>
                                                <div className="f-modal-placeholder"></div>
                                                <div className="f-modal-fix"></div>
                                            </div>
                                }
                            </div>
                            <p>{this.props.message}</p>
                            {
                                this.props.redirectURL != ""
                                    ? (
                                        <Link className="btn btn-secondary btn-block" to={this.props.redirectURL} onClick={e => { this.props.modalClose(); e.stopPropagation(); }}>Okay</Link>
                                    )
                                    : (
                                        <button
                                            className={this.props.isDanger ? "btn btn-danger" : "btn btn-secondary"}
                                            onClick={e => {
                                                e.stopPropagation();
                                                this.props.modalClose();
                                                this.props.actionCall.length != 0
                                                    ?
                                                    this.props.actionCall.map(item => {
                                                        if (typeof item == 'string') {
                                                            this.props.dispatch(actions[`${item}`]());
                                                        } else {
                                                            this.props.dispatch(actions[`${item.actionName}`](item.params));
                                                        }
                                                    })
                                                    : null;
                                            }}
                                        >
                                            {this.props.buttonText ? this.props.buttonText : "Yes"}
                                        </button>
                                    )
                            }
                            <button className="btn btn-primary" onClick={e => { this.props.modalClose(); e.stopPropagation(); }}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ conformationModal }) => {
    const { open, message, withButton, buttonText, notifyType, autoClose, redirectURL, isDanger, actionCall } = conformationModal;
    return { open, message, withButton, buttonText, notifyType, autoClose, redirectURL, isDanger, actionCall };
};

const mapDispatchToProps = dispatch => ({
    modalClose: () => dispatch(actions.conformationModalClose()),

    dispatch
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConformationModal);